import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";

import PostFindItLocal from "./PostFindItLocal";
import FindItLocalList from "./FindItLocalList";
import PostMyLocalNeed from "./PostMyLocalNeed";
import FindItLocalNeedList from "./FindItLocalNeedList";

import { foundHerModules } from "./modules/foundher/FoundHerData";

export default function FoundHerHome() {
    const authState = useSelector((state) => state.authReducer);
    const navigate = useNavigate();

    const userId = authState?.user?._id || null;
    const userCode = authState?.user?.think5whyscode || "";
    const userName = authState?.user?.name || "User";

    const [mode, setMode] = useState({
        view: "LIST",     // LIST | POST | NEED | FINDNEED
        category: "ALL"
    });

    const categories = [
    {
        id: "DIGITAL",
        icon: "💻",
        label: "Digital",
        subcategories: [
        { id: "AI_SERVICES", icon: "🤖", label: "AI Services" },
        { id: "DIGITAL_MARKETING", icon: "📢", label: "Marketing" },
        { id: "WEBSITES", icon: "🌐", label: "Websites" },
        { id: "SOCIAL_MEDIA", icon: "📱", label: "Social Media" },
        { id: "VIRTUAL_ASSISTANT", icon: "🧑‍💼", label: "VA" },
        { id: "CONTENT_CREATION", icon: "✍️", label: "Content" },
        ],
    },
    {
        id: "STORE",
        icon: "🛍️",
        label: "Store",
        subcategories: [
        { id: "FASHION", icon: "👗", label: "Fashion" },
        { id: "JEWELLERY", icon: "💍", label: "Jewellery" },
        { id: "GIFTING", icon: "🎁", label: "Gifting" },
        { id: "RESELLING", icon: "♻️", label: "Reselling" },
        { id: "HANDMADE", icon: "🧶", label: "Handmade" },
        { id: "CURATED", icon: "✨", label: "Curated" },
        ],
    },
    {
        id: "FOOD",
        icon: "🍰",
        label: "Food",
        subcategories: [
        { id: "HOME_BAKERY", icon: "🧁", label: "Bakery" },
        { id: "HEALTHY_FOOD", icon: "🥗", label: "Healthy" },
        { id: "PICKLES", icon: "🥒", label: "Pickles" },
        { id: "CHOCOLATES", icon: "🍫", label: "Chocolate" },
        { id: "SNACKS", icon: "🍿", label: "Snacks" },
        { id: "CLOUD_KITCHEN", icon: "🍳", label: "Cloud Kitchen" },
        ],
    },
    {
        id: "CREATIVE",
        icon: "🎨",
        label: "Creative",
        subcategories: [
        { id: "PHOTOGRAPHY", icon: "📷", label: "Photography" },
        { id: "GRAPHIC_DESIGN", icon: "🖌️", label: "Design" },
        { id: "BRANDING", icon: "🏷️", label: "Branding" },
        { id: "ILLUSTRATION", icon: "🖍️", label: "Illustration" },
        { id: "CRAFTS", icon: "🧵", label: "Crafts" },
        { id: "GIFTS", icon: "🎀", label: "Gifts" },
        ],
    },
    {
        id: "BEAUTY",
        icon: "💄",
        label: "Beauty",
        subcategories: [
        { id: "SALON", icon: "💇", label: "Salon" },
        { id: "SKINCARE", icon: "🧴", label: "Skincare" },
        { id: "FITNESS", icon: "🏋️", label: "Fitness" },
        { id: "YOGA", icon: "🧘", label: "Yoga" },
        { id: "MAKEUP", icon: "💋", label: "Makeup" },
        { id: "WELLNESS", icon: "🌿", label: "Wellness" },
        ],
    },
    {
        id: "EDUCATION",
        icon: "🎓",
        label: "Education",
        subcategories: [
        { id: "TUTORING", icon: "📖", label: "Tutoring" },
        { id: "COACHING", icon: "🎯", label: "Coaching" },
        { id: "ONLINE_CLASSES", icon: "💻", label: "Online" },
        { id: "WORKSHOPS", icon: "🛠️", label: "Workshops" },
        { id: "SKILLS", icon: "🚀", label: "Skills" },
        ],
    },
    {
        id: "AGRI",
        icon: "🌾",
        label: "Agri",
        subcategories: [
        { id: "MILLETS", icon: "🌾", label: "Millets" },
        { id: "SPICES", icon: "🧂", label: "Spices" },
        { id: "HONEY", icon: "🍯", label: "Honey" },
        { id: "HANDICRAFTS", icon: "🪆", label: "Crafts" },
        { id: "SHG", icon: "🤝", label: "SHGs" },
        { id: "FARM_PRODUCTS", icon: "🚜", label: "Farm" },
        ],
    },
    {
        id: "BOUTIQUE",
        icon: "🏪",
        label: "Boutique",
        subcategories: [
        { id: "DISTRIBUTOR", icon: "📦", label: "Distributor" },
        { id: "COORDINATOR", icon: "👩‍💼", label: "Coordinator" },
        { id: "COMMUNITY", icon: "🏘️", label: "Community" },
        { id: "DIGITAL_BOUTIQUE", icon: "🏪", label: "Boutique" },
        ],
    },
    ];

    const handleModuleClick = (module) => {
        switch (module.action) {
            case "localListing":
                setMode(prev => ({ ...prev, view: "LOCALLIST" }));
                break;

            case "findNeeds":
                setMode(prev => ({ ...prev, view: "FINDNEED" }));
                break;

            case "postNeed":
                setMode(prev => ({ ...prev, view: "NEED" }));
                break;
            
            case "herKart":
                navigate("/herkart");
                break;

            case "herOneView":
                navigate("/foundheroneview");
                break;

            case "hustles":
                navigate("/hustle");
                break;

            case "innovations":
                navigate("/foundher-innovationhub");
                break;

            case "herBrands":
                navigate("/foundher-brands");
                break;     
                
            case "spotlight":
                navigate("/foundher-spotlight");
                break;   

            case "supportAFoundher":
                navigate("/foundher-support");
                break;  

            case "nabora":
                navigate("/nabora/foundher");
                break;

            case "vocalForLocal":
                navigate("/vocalforlocal/foundher");
                break;

            default:
                // console.log("No handler for:", module.action);
        }
    };

    const renderContent = () => {
        switch (mode.view) {
            case "LOCALLIST":
                return <FindItLocalList category={mode.category} />;

            case "INNOVATIONS":
                return <FindItLocalList category={mode.category} />;

            case "NEED":
                return <PostMyLocalNeed userId={userId} />;

            case "FINDNEED":
                return <FindItLocalNeedList />;

            default:
                return <FindItLocalNeedList />;
        }
    };

    return (
        <div className="min-h-screen bg-[#0b0f19] text-white flex flex-col">
            <div className="sticky top-0 z-20 bg-gradient-to-r from-pink-600 via-fuchsia-600 to-purple-700 border-b border-purple-900 shadow-lg rounded-b-3xl px-4 py-4">
                <div className="flex items-center justify-between">
                    <div>
                        <div className="flex items-center gap-2">
                            <span className="text-3xl lg:text-5xl">💜</span>
                            <div>
                                <h1 className="text-white text-start text-lg lg:text-2xl font-extrabold tracking-tight">
                                    FoundHer
                                </h1>
                                <p className="text-pink-100 text-xs lg:text-sm mt-0.5">
                                    Everybody Empowers the Local GenZ Women!
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* <div className="flex rounded-xl bg-white/10 backdrop-blur-md border border-white/20"> */}
                    <button
                        onClick={() => navigate("/foundherjourney")}
                        className="w-fit px-3 py-1 rounded-xl text-xs lg:text-sm font-semibold bg-gradient-to-r from-pink-500 to-fuchsia-600 hover:scale-105 active:scale-95 transition-all shadow-xl shadow-pink-500/30"
                    >
                        🌱 Belief Journey
                    </button>
                    {/* </div> */}
                </div>
                <div className="mt-2 inline-flex items-center gap-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 px-3 py-1">
                    <span className="text-sm">👋</span>
                    <span className="text-xs text-white font-semibold">
                        {userName}
                    </span>
                    <span className="text-pink-200 text-xs">
                        • {userCode}
                    </span>
                </div>
            </div>

            {/* ACTION BAR */}
            <div className="grid grid-cols-2 lg:grid-cols-5 place-items-center bg-[#0f172a] border-l border-t border-purple-900 mt-2 gap-1 mb-2">
                {foundHerModules
                    .filter(module =>
                        [
                            "herKart",
                            "localListing",
                            "findNeeds",
                            "postNeed",
                            "hustles",
                            "innovations",
                            "herBrands",
                            "spotlight",
                            "supportAFoundher",
                            "nabora",
                            "vocalForLocal",
                            "herOneView",                            
                        ].includes(module.action)
                    )
                    .map(module => (
                        <button
                            key={module.view}
                            onClick={() => handleModuleClick(module)}
                            className="flex justify-start text px-1 py-1.5 bg-purple-700 hover:bg-purple-600 text-white text-xs lg:text-xs font-bold border-r border-b border-purple-900 leading-none"
                        >
                            {module.icon} {module.label}
                        </button>
                    ))}
            </div>

            {/* CATEGORY TABS - only show when LOCALLIST is active */}
            {mode.view === "LOCALLIST" && (
                <div className="flex flex-wrap gap-1 bg-[#111827] border-t-2 border-pink-400 rounded-2xl">
                    {categories.map((category) => (
                        <button
                            key={category.id}
                            onClick={() =>
                                setMode(prev => ({
                                    ...prev,
                                    view: "LOCALLIST",
                                    category: category.id,
                                    subcategory: category.subcategories[0].id,
                                }))
                            }
                            className={`flex flex-col items-center justify-center leading-none px-3 py-1 w-fit
                                ${
                                    mode.category === category.id
                                        ? "text-pink-200"
                                        : "text-gray-200"
                                }`}
                        >
                            <span className="text-[18px]">{category.icon}</span>
                            <span className="text-xs lg:text-sm leading-none">
                                {category.label}
                            </span>
                        </button>
                    ))}
                </div>
            )}

            <div className="flex flex-wrap gap-1">
                {categories
                    .find(c => c.id === mode.category)
                    ?.subcategories.map(sub => (
                        <button
                            key={sub.id}
                            onClick={() =>
                                setMode(prev => ({
                                    ...prev,
                                    subcategory: sub.id,
                                }))
                            }
                            className={`w-fit px-2 py-1 rounded-lg text-xs ${
                                mode.subcategory === sub.id
                                    ? "bg-pink-500 text-white"
                                    : "bg-gray-800 text-gray-300"
                            }`}
                        >
                            {sub.icon} {sub.label}
                        </button>
                ))}
            </div>

            {/* CONTENT */}
            <div className="flex-1 overflow-y-auto px-3 pb-4">
                {renderContent()}
            </div>
        </div>
    );
}